import { render, staticRenderFns } from "./LocalMediaControls.vue?vue&type=template&id=1f582f78&"
import script from "./LocalMediaControls.vue?vue&type=script&lang=js&"
export * from "./LocalMediaControls.vue?vue&type=script&lang=js&"
import style0 from "./LocalMediaControls.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
